/**
 * 제안형 수락/거절이 "수락 응답 기한 만료" 로 차단될 때 BE 가 내려주는 전용 에러 코드. (CMQA-7164, BE PR783)
 * 제안 응답 기한(48h) 경과 후 수락/거절 시 409 SEEDING-001-007 반환. 일반 실패 토스트
 * ("거절 처리에 실패했습니다…") 대신 "마감" 안내로 분기하기 위한 판정.
 */
export const ERROR_CODE_SEEDING_PROPOSAL_EXPIRED = 'SEEDING-001-007';

/**
 * mutation onError 로 들어온 에러가 "제안 응답 기한 만료(SEEDING-001-007)" 인지 판정한다.
 *
 * non-2xx HTTP 응답만 대상. `executeStandardRequest` 가 non-2xx 를 `{ data, status, message }`
 * 평문 객체로 reject 하며 BE errorCode 는 `error.data.meta.errorCode` 경로에 담긴다.
 * (패널티 `SEEDING-001-010` 와 동일 엔드포인트·동일 transport — [[isSeedingPenaltyError]] 와 동형.)
 */
export const isSeedingProposalExpiredError = (error: unknown): boolean => {
  if (typeof error !== 'object' || error === null || !('data' in error)) return false;
  const { data } = error as { data?: unknown };
  if (typeof data !== 'object' || data === null || !('meta' in data)) return false;
  const { meta } = data as { meta?: unknown };
  if (typeof meta !== 'object' || meta === null || !('errorCode' in meta)) return false;
  const { errorCode } = meta as { errorCode?: unknown };
  return errorCode === ERROR_CODE_SEEDING_PROPOSAL_EXPIRED;
};
